export default __webpack_public_path__ + "static/media/twitter.5f444742.png";